import { Button, Card, CircularProgress } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import withRouter from "hoc/withRouter";
import { useGetAIFunctions } from "hooks/useGetAIFunctions";
import { AIFunctionCard } from "../components/AIFunctionCard/AIFunctionCard";
import { IAIFunction } from "interfaces/entities/ai-function.interface";

const AgentFunctions = ({
  router: {
    params: { id: agentID },
  },
}: any) => {
  const navigate = useNavigate();
  const { data, isLoading, error } = useGetAIFunctions(Number(agentID));

  return (
    <div>
      <h1>Функции агента</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">
        <Card>
          <div className="flex justify-center items-center w-full h-full">
            <div className="flex justify-center items-center">
              <Button
                variant="text"
                color="primary"
                onClick={() => navigate(`/admin/ai-agents/${agentID}/functions/add`)}
              >
                Создать функцию <FaPlus className="ml-4" />
              </Button>
            </div>
          </div>
        </Card>
        {isLoading ? (
          <CircularProgress />
        ) : error ? (
          <div>Error: {error?.message}</div>
        ) : (
          data?.rows?.map((aiFunction: IAIFunction) => (
            <AIFunctionCard key={aiFunction.id} aiFunction={aiFunction} />
          ))
        )}
      </div>
    </div>
  );
};

export default withRouter(AgentFunctions);
